import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/licensed-establishment/reward-programs/redemptions'
const method = 'get'

interface UseGetRewardRedemptionsByLeIdParams {
  licensedEstablishmentId: number
  startDate: Date
  endDate: Date
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd HH:mm:ss')

export const useGetRewardRedemptionsByLeIdForExport = ({
  licensedEstablishmentId,
  startDate,
  endDate,
}: UseGetRewardRedemptionsByLeIdParams) =>
  useApiQuery({
    path,
    method,
    queryKey: [
      '/le-connect/licensed-establishment/reward-programs/redemptions/export',
      licensedEstablishmentId,
      formatDate(startDate),
      formatDate(endDate),
    ],
    queryArgs: {
      currentPage: 1,
      pageSize: 1000000,
      licensedEstablishmentId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
  })
